import { Urls } from '@/lib/urls';

const ANONYMOUS_ROUTES = [
  Urls.integrationFlow.fortnox.activation,
  Urls.integrationFlow.vismaEEconomy.activation,
  Urls.f.anonymousLinks,
  Urls.privacyPolicy,
  Urls.anonymousErrand('', '').slice(0, -2),
];

const ANONYMOUS_PATTERNS = [
  /^\/notification\/[^/]+\/?$/,
  /^\/notification\/native\/[^/]+\/?$/,
];

// Helper function to check if a path matches any anonymous routes
export const isAnonymousRoute = (pathname: string): boolean => {
  const doesSomePatternMatch = ANONYMOUS_PATTERNS.some((pattern) =>
    pattern.test(pathname)
  );
  if (doesSomePatternMatch) {
    return true;
  }
  return ANONYMOUS_ROUTES.some((r) => {
    return pathname.startsWith(r);
  });
};

// Helper function to check if a path is a login route
export const isLoginRoute = (pathname: string): boolean => {
  return pathname.startsWith('/login');
};
